export default {
  'financeReconciliation.pageTitle': 'Financial Reconciliation',
  'financeReconciliation.pageSubTitle':
    'Records with uploaded bank statement attachments are marked as settled',
  'financeReconciliation.emptyHint':
    'Select a bank account and billing period to view reconciliation details',
  'financeReconciliation.bankAccount': 'Bank Account',
  'financeReconciliation.accountPeriod': 'Account Period',
  'financeReconciliation.statementNo': 'Statement No.',
  'financeReconciliation.currency': 'Currency',
  'financeReconciliation.filterTitle': 'Filters',
  'financeReconciliation.transactionList': 'Transactions',
  'financeReconciliation.clearImportedData': 'Clear Data',
  'financeReconciliation.clearImportedDataModalTitle': 'Clear Imported Data',
  'financeReconciliation.clearImportedDataModalContent':
    'Clear all imported bank transactions and related records for this period? This action cannot be undone.',
  'financeReconciliation.clearImportedDataSuccess': 'Imported data cleared',
  'financeReconciliation.clearImportedDataFailed':
    'Failed to clear imported data',
  'financeReconciliation.exportStatement': 'Export Statement',
  'financeReconciliation.monthlyStatement': 'Monthly Statement',
  'financeReconciliation.statementPeriod': 'Statement Period',
  'financeReconciliation.opening': 'Opening Balance',
  'financeReconciliation.credit': 'Credit (Income)',
  'financeReconciliation.debit': 'Debit (Expense)',
  'financeReconciliation.closing': 'Closing Balance',
  'financeReconciliation.transactionDate': 'Transaction Date',
  'financeReconciliation.matchStatus': 'Match Status',
  'financeReconciliation.description': 'Description / Counterparty',
  'financeReconciliation.transferRemark': 'Transfer Remark',
  'financeReconciliation.bankRemark': 'Bank Remark',
  'financeReconciliation.amount': 'Amount',
  'financeReconciliation.diffAmount': 'Difference',
  'financeReconciliation.debitOut': 'Debit (OUT)',
  'financeReconciliation.creditIn': 'Credit (IN)',
  'financeReconciliation.balance': 'Balance (BAL)',
  'financeReconciliation.totalSummary': 'TOTAL SUMMARY',
  'financeReconciliation.pageSummary': 'Page Summary',
  'financeReconciliation.selectBankAccount': 'Please select bank account',
  'financeReconciliation.selectAccountPeriod': 'Please select account period',
  'financeReconciliation.includeUnsettled': 'Include Unsettled',
  'financeReconciliation.createDetail': 'New Entry',
  'financeReconciliation.settleStatement': 'Statement Settlement',
  'financeReconciliation.importStatement': 'Import Statement',
  'financeReconciliation.import.bankNameLabel': 'Bank Template Type',
  'financeReconciliation.import.selectBankName':
    'Please select bank template type',
  'financeReconciliation.import.uploadHint':
    'Click or drag Excel file here to upload',
  'financeReconciliation.import.uploadFormat': 'Supports .xlsx, .xls formats',
  'financeReconciliation.import.uploading': 'Importing statement...',
  'financeReconciliation.import.success': 'Statement imported successfully',
  'financeReconciliation.import.failed': 'Failed to import statement',
  'financeReconciliation.import.loadBankFailed':
    'Failed to load bank template types',
  'financeReconciliation.import.missingStatement':
    'Please select a billing period first',
  'financeReconciliation.searchPlaceholder': 'Search description or voucher',
  'financeReconciliation.refresh': 'Refresh',
  'financeReconciliation.unsettledBadge': 'Unsettled',
  'financeReconciliation.filter.all': 'All',
  'financeReconciliation.filter.skipped': 'Skipped',
  'financeReconciliation.matchStatus.pending': 'Pending',
  'financeReconciliation.matchStatus.matched': 'Matched',
  'financeReconciliation.matchStatus.unknown': 'Unknown',
  'financeReconciliation.matchStatus.partialMatch': 'Partial Match',
  'financeReconciliation.status.settled': 'Settled',
  'financeReconciliation.status.unsettled': 'Unsettled',
  'financeReconciliation.match.drawerTitle': 'Manual Transaction Match',
  'financeReconciliation.match.bankInfo': 'Bank Account Info',
  'financeReconciliation.match.transactionInfo': 'Current Transaction',
  'financeReconciliation.match.filterTitle': 'Match Filters',
  'financeReconciliation.match.candidateList': 'Candidate Records',
  'financeReconciliation.match.candidateCount': '{count} records',
  'financeReconciliation.match.noCandidates': 'No matching records found',
  'financeReconciliation.match.amountType': 'Direction',
  'financeReconciliation.match.confirm': 'Confirm Match',
  'financeReconciliation.match.success': 'Matched successfully',
  'financeReconciliation.match.failed': 'Match failed',
  'financeReconciliation.match.loadExpenseFailed':
    'Failed to load candidate records',
  'financeReconciliation.match.selectExpenseRequired':
    'Please select an expense record to match',
  'financeReconciliation.match.manualBadge': 'Manual',
  'financeReconciliation.match.transactionAmount': 'Amount ({currency})',
  'financeReconciliation.match.remarkPrefix': 'Remark',
  'financeReconciliation.match.searchKeyword': 'Keyword Search',
  'financeReconciliation.match.searchPlaceholder':
    'Search code, name or amount...',
  'financeReconciliation.match.houseSelectPlaceholder': 'Please select house',
  'financeReconciliation.match.parkingSelectPlaceholder':
    'Please select parking',
  'financeReconciliation.match.dateRange': 'Date Range',
  'financeReconciliation.match.resetFilters': 'Reset Filters',
  'financeReconciliation.match.selectHint':
    'Select a local record below to reconcile',
  'financeReconciliation.match.targetAmount': 'Target amount: {amount}',
  'financeReconciliation.match.perfectMatch': 'Amount matches perfectly!',
  'financeReconciliation.match.amountSummary':
    'Target: {target} | Selected: {selected}',
  'financeReconciliation.match.finalAmountSummary':
    'Due: {target} | Previously matched: {previous} | Current: {selected} | Final: {final}',
  'financeReconciliation.match.perfectBadge': 'Perfect Match',
  'financeReconciliation.match.amountMismatch': 'Amount mismatch',
  'financeReconciliation.match.shortBy': 'Short by {amount}',
  'financeReconciliation.match.overBy': 'Over by {amount}',
  'financeReconciliation.match.filteredCount': '({count} records filtered)',
  'financeReconciliation.match.expenseDetailSuffix': 'Expense details',
  'financeReconciliation.match.mortgageRepaymentSuffix': '(Mortgage repayment)',
  'financeReconciliation.match.carRepaymentSuffix': '(Car repayment)',
  'financeReconciliation.match.autoRecommend': 'Auto Find Match',
  'financeReconciliation.match.autoRecommendSuccess':
    'Recommended a matching record',
  'financeReconciliation.match.autoRecommendFailed':
    'No exact amount match found',
  'financeReconciliation.match.selectionSummary':
    '1 record selected, amount {amount}',
  'financeReconciliation.match.pendingPageSummary':
    '{count} records on this page, total {amount}',
  'financeReconciliation.match.noSelection': 'No record selected',
  'financeReconciliation.match.footerHint':
    'Confirm match when amounts align perfectly',
  'financeReconciliation.match.clearSelection': 'Clear Selection',
  'financeReconciliation.match.markUnknown': 'Mark Unknown',
  'financeReconciliation.match.markUnknownSuccess':
    'Marked as unknown transaction',
  'financeReconciliation.match.markUnknownFailed': 'Failed to mark as unknown',
  'financeReconciliation.match.markUnknownModalTitle':
    'Mark Unknown Transaction',
  'financeReconciliation.match.markUnknownModalContent':
    'Mark this transaction as unknown? It will be excluded from further matching in this reconciliation.',
  'financeReconciliation.match.confirmModalTitle': 'Confirm Match',
  'financeReconciliation.match.confirmModalPerfectDesc':
    'Actual repayment amount matches the due amount',
  'financeReconciliation.match.confirmModalPerfectQuestion':
    'Confirm and post this match?',
  'financeReconciliation.match.confirmModalForceDesc':
    'Actual repayment amount does not match the due amount',
  'financeReconciliation.match.confirmModalForceQuestion':
    'Force match anyway?',
  'financeReconciliation.match.confirmModalStatusLabel': 'Match Status',
  'financeReconciliation.match.confirmModalStatusMatchedDesc':
    'Amounts fully align — mark as matched',
  'financeReconciliation.match.confirmModalStatusPartialDesc':
    'Amounts not fully aligned — mark as partial match',
  'financeReconciliation.match.confirmModalTransactionAmount': 'Transaction',
  'financeReconciliation.match.confirmModalRecordAmount': 'Record',
  'financeReconciliation.match.confirmModalShortfall': 'Short by',
  'financeReconciliation.match.confirmModalOverage': 'Over by',
  'financeReconciliation.match.remarksLabel': 'Remarks',
  'financeReconciliation.match.remarksPlaceholder': 'Click to add remarks',
  'financeReconciliation.match.remarksModalTitle': 'Edit Remarks',
  'financeReconciliation.match.remarksInputPlaceholder': 'Enter remarks',
  'financeReconciliation.match.remarksUpdateSuccess': 'Remarks updated',
  'financeReconciliation.match.remarksUpdateFailed': 'Failed to update remarks',
  'financeReconciliation.match.categoryLabel': 'Bank Statement Match Category',
  'financeReconciliation.match.category.dailyExpense': 'General Transaction Link',
  'financeReconciliation.match.category.realEstate': 'Mortgage Repayment Link',
  'financeReconciliation.match.category.propertyFee': 'Property Fee Link',
  'financeReconciliation.match.alreadyMatched':
    'This record is already matched to a bank transaction and cannot be added again',
  'financeReconciliation.match.dueAmount': 'Due Amount',
  'financeReconciliation.match.actualAmount': 'Actual Amount',
  'financeReconciliation.match.previousMatchedAmount': 'Previously Matched',
  'financeReconciliation.match.finalAmount': 'Final Amount',
  'financeReconciliation.match.finalAmountPending': 'Final Amount (Pending Check)',
};
